import { SDEForm } from "./sde-m-form";

class SDEContactForm extends SDEForm {
  protected get submitUrl(): string {
    return "https://mail.suederende.de/v1/sendMail";
  }

  protected get submitBody(): Record<string, any> | undefined {
    const submitData = this.submitData;
    if (submitData.length === 0) {
      return undefined;
    }

    const from = {
      name: submitData.find(data => data.name === "name")?.value ?? "",
      mail: submitData.find(data => data.name === "mail")?.value ?? "",
    };

    const to = {
      name: "Gemeinde Süderende",
      mail: "dev@riewerts.io",
    };

    return {
      ...super.submitBody,
      from,
      to,
      subject: "Nachricht über Kontaktformular suederende.de",
    };
  }
}

customElements.define("sde-m-contact-form", SDEContactForm);
